// The Nutaku platform slots the server knows (spec/api-conventions.md section 15.4), with their legacy codes; the
// platforms page shows one card per slot and the products grid offers them for a platform override (spec/dashboard.md 9.10–9.11).
export interface PlatformSlot {
  slug: string;
  code: number;
  label: string;
}

export const NUTAKU_SLOTS: PlatformSlot[] = [
  { slug: 'nutaku_pc_browser', code: 9, label: 'Nutaku PC browser' },
  { slug: 'nutaku_sp_browser', code: 10, label: 'Nutaku SP browser' },
  { slug: 'nutaku_android', code: 11, label: 'Nutaku Android' },
  { slug: 'nutaku_client_games', code: 12, label: 'Nutaku client games' },
  { slug: 'nutaku_ios', code: 41, label: 'Nutaku iOS' },
];

/** A product platform slug (section 19.1): `default`, `all` or a store platform. */
export const PLATFORM_SLUG = /^[a-z0-9][a-z0-9_-]{0,31}$/;
